module.exports = __webpack_public_path__ + "h5/img/detail-opt3.a5061bbf.png";